import { Navigate } from "react-router-dom";

interface Props {
  element: React.ReactNode;
  hasGestorURL: boolean;
}

export const ProtectedRouteGestorAdmin = ({ element, hasGestorURL }: Props) => {
  if (!hasGestorURL) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{element}</>;
};
